const LOCAL_EN = "en-CA";
const LOCAL_FR = "fr-CA";
const DEFAULT_GATEWAY_EN = "YYZ";
const DEFAULT_GATEWAY_FR = "YUL";
const LOCAL_DAYJS_EN = "en";
const LOCAL_DAYJS_FR = "fr";
const AD_MODULE_OFFER_TYPE_PACKAGE = "Package";
const AD_MODULE_OFFER_TYPE_RETURN_FLIGHT = "Flight";
const AD_MODULE_OFFER_TYPE_ONE_WAY_FLIGHT = "FlightOneWay";
const LOCAL_STORAGE_KEY_PREFERRED_GATEWAY = "preferredGateway";

module.exports = {
	LOCAL_EN,
	LOCAL_FR,
	DEFAULT_GATEWAY_EN,
	DEFAULT_GATEWAY_FR,
	LOCAL_DAYJS_EN,
	LOCAL_DAYJS_FR,
	AD_MODULE_OFFER_TYPE_PACKAGE,
	AD_MODULE_OFFER_TYPE_RETURN_FLIGHT,
	AD_MODULE_OFFER_TYPE_ONE_WAY_FLIGHT,
	LOCAL_STORAGE_KEY_PREFERRED_GATEWAY,
};
